import { useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";

// The flat bottom prints in ONE filament. Default is the dominant colour already on the cap (or the light filament of
// the QR contrast pair); the owner can pick any slot of this duck's own palette. New exports only — files already
// frozen onto an order never change.
export const BaseColourPicker = ({ creation, onUpdate }) => {
  const [busy, setBusy] = useState(false);
  const palette = creation.palette || [];
  const baseSlot = creation.print_options?.base_slot;
  if (palette.length < 2) return null;

  const pick = async (slot) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/creations/${creation.id}/print-options`, { base_slot: slot });
      onUpdate?.(data);
      toast.success(`The flat bottom will print in ${palette[slot]?.name || palette[slot]?.hex}.`);
    } catch {
      toast.error("Could not save the base colour.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="base-colour-card" className="rounded-2xl border border-border bg-card/60 px-4 py-3">
      <p className="text-sm font-semibold">Base colour · the flat bottom prints in one filament</p>
      <div data-testid="base-colour-picker" className="mt-2 flex flex-wrap gap-2">
        {palette.map((p, i) => (
          <button
            key={p.slot ?? i}
            type="button"
            data-testid={`base-colour-${i}`}
            disabled={busy}
            onClick={() => pick(i)}
            title={`${p.name || p.hex} — slot ${i + 1}`}
            aria-label={`Base colour slot ${i + 1}: ${p.name || p.hex}`}
            className={`h-8 w-8 rounded-full border-2 transition-transform hover:scale-110 ${baseSlot === i ? "border-accent ring-2 ring-accent/40" : "border-border"}`}
            style={{ background: p.hex }}
          />
        ))}
      </div>
      <p data-testid="base-colour-note" className="text-xs text-muted-foreground mt-2">
        {baseSlot != null ? `Bottom prints in ${palette[baseSlot]?.name || palette[baseSlot]?.hex}. ` : ""}
        Applies to new exports — files already frozen onto an order never change.
      </p>
    </div>
  );
};
